import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  SSOErrorWrapper,
  SSOErrorHeader,
  SSOErrorDescription,
  SSOErrorActionsHeading,
  SSOContactSupport,
  MaintenanceContent,
} from '../styles';

export const RouteOneMaintenance: React.FC = () => {
  const { t } = useTranslation();

  return (
    <SSOErrorWrapper>
      <MaintenanceContent>
        <SSOErrorHeader>{t('components.ssoMaintenancePage.title')}</SSOErrorHeader>
        <SSOErrorDescription>{t('components.ssoMaintenancePage.description')}</SSOErrorDescription>
        <SSOErrorActionsHeading>{t('components.ssoMaintenancePage.whatYouCanDo.heading')}</SSOErrorActionsHeading>
        {/* <SSOErrorActionsList>
          <li>{t('components.ssoMaintenancePage.whatYouCanDo.item1')}</li>
        </SSOErrorActionsList> */}
        <SSOContactSupport>
          <div>
            {t('components.ssoErrorPage.contactSupport.text')}{' '}
            <a href={`mailto:${t('components.ssoErrorPage.contactSupport.email')}`}>
              {t('components.ssoErrorPage.contactSupport.email')}
            </a>{' '}
            {t('components.ssoErrorPage.contactSupport.textPostfix')}
          </div>
        </SSOContactSupport>
      </MaintenanceContent>
    </SSOErrorWrapper>
  );
};
